import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';
import {useRouter} from 'next/router';

// Will be replaced with the internal link to the dedicated feature when ready
const FALLBACK_CTA_LINKS: {default: string; fr: string} = {
	default:
		'https://newsroom-deezer.com/2025/10/deezer-makes-it-possible-to-share-playlists-with-friends-on-other-platforms/',
	fr: 'https://newsroom-deezer.com/fr/2025/10/deezer-permet-desormais-de-partager-ses-playlists-avec-des-amis-sur-dautres-plateformes/',
};

export const UniversalSharingSection: FunctionComponent = () => {
	const {locale} = useRouter();
	const {t} = useTranslation();
	const ctaLink =
		locale === 'fr' ? FALLBACK_CTA_LINKS.fr : FALLBACK_CTA_LINKS.default;
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading
						as="h2"
						dangerouslySetInnerHTML={{
							__html: t(
								'featureslandingpage_title_musicwithoutborders_standalone-web',
								{ns: 'features'},
							),
						}}
					/>
					<LandingParagraph>
						{t(
							'featureslandingpage_text_sharefavtrackwithfriendsonanyplatform_standalone-web',
							{ns: 'features'},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					h={{base: '250px', md: '100%'}}
					alt={'universal-sharing'}
					quality={90}
					objectFit={{base: 'cover', sm: 'contain'}}
					aspectRatio="1860/824"
					src={'acc67f1a08ffda46181abe901bf0bb85.png'}
					width={{base: '100%', md: '70%'}}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'universal-sharing'}}
					href={ctaLink}
				>
					{t('generic_action_discover_standalone-web', {ns: 'features'})}
				</LandingButtonLink>
			}
		/>
	);
};
